import React, { useEffect, useLayoutEffect, useState } from 'react';
import styles from './styles.module.css';
import TitleAndDesc from '../../components/TitleAndDesc/TitleAndDesc';
import Modal from './Modal';
import Button from '../../components/Button';
import { useDispatch, useSelector } from 'react-redux';
import { getUsers } from '../../actions/users';
import { Link, redirect } from 'react-router-dom';

const UsersPage = () => {
  const dispatch = useDispatch();
  const { loading, list } = useSelector((state) => state.users);

  const [modal, setModal] = useState(null);

  const { superuser } = useSelector((state) => state.auth.user);

  const [accessDenied, setAccessDenied] = useState(false);

  useEffect(() => {
    if (!superuser) {
      setAccessDenied(true);
      return;
    }

    dispatch(getUsers());
  }, [superuser]);

  if (accessDenied) {
    return (
      <div className={styles.wrapper}>
        <TitleAndDesc title="Пользователи" />
        <div className={styles.accessDenied}>
          <div className={styles.icon}>🚫</div>
          <h2>Недостаточно прав для просмотра этой страницы</h2>
          <p>Обратитесь к администратору, чтобы получить доступ.</p>
          <Link to="/pos" className={styles.backBtn}>
            ⬅ Вернуться на главную
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      <TitleAndDesc title="Список пользователей" desc="" />

      {modal && <Modal modal={modal} setModal={setModal} />}

      <div className={styles.tableWrapper}>
        <table className={styles.table} cellSpacing="0">
          <thead className={styles.thead}>
            <tr>
              <th>ID</th>
              <th>Логин</th>
              <th>E-mail</th>
              <th>Статус</th>
              <th>Права</th>
              <th>Дата регистрации</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="6" className={styles.loading}>
                  Загрузка пользователей...
                </td>
              </tr>
            ) : (
              list.map((el) => (
                <tr key={el.id} className={styles.row} onClick={() => setModal(el)}>
                  <td>{el.id}</td>
                  <td>{el.username}</td>
                  <td>{el.email}</td>
                  <td>
                    <span
                      className={`${styles.badge} ${
                        el.is_active ? styles.active : styles.inactive
                      }`}
                    >
                      {el.is_active ? 'Активен' : 'Неактивен'}
                    </span>
                  </td>
                  <td>
                    <span
                      className={`${styles.badge} ${el.superuser ? styles.super : styles.normal}`}
                    >
                      {el.superuser ? 'Админ' : 'Пользователь'}
                    </span>
                  </td>
                  <td>
                    {new Date(el.created_at).toLocaleDateString('ru-RU', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* <div className={styles.buttons}>
        <Button
          mr=".5rem 0"
          text="Добавить пользователя"
          type="primary"
          onClick={() => setModal(true)}
        />
      </div> */}
    </div>
  );
};

export default UsersPage;
